// extracted by mini-css-extract-plugin
export default {"FirstSection":"NewBike_FirstSection__B1xEr","Left":"NewBike_Left__Ewp5N","DescriptionField":"NewBike_DescriptionField__WZyHw","ImgInput":"NewBike_ImgInput__JQp57"};